import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import SearchBar from '../Main/searchBar';
import { useDispatch, useSelector } from 'react-redux';
// import { AdminConstants } from './AdminConstants';
import "./viewAdmin.css";
import { viewAdmin, addAccessCode, removeAccessCode } from '../../Redux/Actions/adminActions';
import getCountryNameByCode from '../../Global Functions/Country';
import toast from "react-hot-toast";

const ViewAdmin = () => {
    const { id } = useParams();
    const dispatch = useDispatch();

    const [showAccessInput, setShowAccessInput] = useState(false);
    const [selectedAccessTypes, setSelectedAccessTypes] = useState([]);

    const { admin } = useSelector((state) => state.admin);
    const { singleAdmin } = useSelector((state) => state.viewAdmin || {});

    const ACCESS_TYPES = {
        ADD: 'add',
        EDIT: 'edit'
    };

    useEffect(() => {
        if (id) {
            dispatch(viewAdmin(id));
        }
    }, [dispatch, id]);

    useEffect(() => {
        // Pre-populate selected access types when admin data loads
        if (singleAdmin?.data?.access_code && Array.isArray(singleAdmin.data.access_code)) {
            const validAccess = singleAdmin.data.access_code.filter(
                type => type === ACCESS_TYPES.ADD || type === ACCESS_TYPES.EDIT
            );
            setSelectedAccessTypes(validAccess);
        }
    }, [singleAdmin?.data?.access_code]);

    const handleClickGiveAccess = () => {
        setShowAccessInput(true);
        // Pre-populate with current access types
        if (singleAdmin?.data?.access_code && Array.isArray(singleAdmin.data.access_code)) {
            const validAccess = singleAdmin.data.access_code.filter(
                type => type === ACCESS_TYPES.ADD || type === ACCESS_TYPES.EDIT
            );
            setSelectedAccessTypes(validAccess);
        }
    };

    const handleAccessTypeToggle = (accessType) => {
        setSelectedAccessTypes(prev => {
            if (prev.includes(accessType)) {
                return prev.filter(type => type !== accessType);
            } else {
                return [...prev, accessType];
            }
        });
    };

    const handleSaveAccess = async () => {
        if (!singleAdmin?.data?._id || selectedAccessTypes.length === 0) {
            toast.error('Please select at least one access type');
            return;
        }

        const payload = {
            login_role: admin.data.role,
            admin_id: singleAdmin.data._id,
            access_code: selectedAccessTypes
        };

        try {
            await dispatch(addAccessCode(payload));
            if (id) {
                dispatch(viewAdmin(id));
            }
            setShowAccessInput(false);
        } catch (err) {
            toast.error(err?.message || 'Failed to save access code');
        }
    };

    const handleRemoveAccess = async () => {
        if (!singleAdmin?.data?._id) return;

        const payload = {
            login_role: admin.data.role,
            admin_id: singleAdmin.data._id
        };

        try {
            await dispatch(removeAccessCode(payload));
            if (id) {
                dispatch(viewAdmin(id));
            }
            setShowAccessInput(false);
            setSelectedAccessTypes([]);
        } catch (err) {
            toast.error(err?.message || 'Failed to remove access code');
        }
    };

    const hasAccessCode = singleAdmin?.data?.access_code && 
                          Array.isArray(singleAdmin.data.access_code) && 
                          singleAdmin.data.access_code.some(type => 
                              type === ACCESS_TYPES.ADD || type === ACCESS_TYPES.EDIT
                          );

    const capitalizeFirst = str =>
        str ? str.charAt(0).toUpperCase() + str.slice(1) : '';

    return (
        <div className="viewAdmin-container">
            <div className="searchbar-wrapper">
                <div className="searchbar-container">
                    <SearchBar />
                </div>
            </div>

            <div className="viewAdmin-row-one">
                <div className="viewAdmin-header">
                    <Link to="/manage_admins">
                        <BackIcon className="back-icon" />
                    </Link>
                    <span className="admin-title">
                        Admin Details
                    </span>
                </div>
            </div>

            <div className='viewAdmin-content-new'>
                {/* Profile Card */}
                <div className='profile-card'>
                    <div className="profile-image-wrapper">
                        <img
                            src={
                                singleAdmin?.data?.profile_image
                                    ? singleAdmin.data.profile_image
                                    : require("../../Global Icons/AlternateImage.png")
                            }
                            alt="Admin Profile"
                            className="profile-image-new"
                        />
                    </div>
                    <div className='profile-info'>
                        <h2 className='profile-name'>{singleAdmin?.data?.name}</h2>
                        <p className="profile-role">
                            {capitalizeFirst(singleAdmin?.data?.role)}
                        </p>
                        <div className='profile-status-badge'>
                            <span className='status-dot'></span>
                            Active
                        </div>
                    </div>
                </div>

                {/* Information Grid */}
                <div className='info-grid'>
                    {/* Personal Information Section */}
                    <div className='info-section'>
                        <h3 className='section-title'>Personal Information</h3>
                        <div className='info-items'>
                            <div className='info-item'>
                                <span className='info-label'>Employee ID</span>
                                <span className='info-value'>{singleAdmin?.data?.admin_id}</span>
                            </div>
                            <div className='info-item'>
                                <span className='info-label'>Email Address</span>
                                <span className='info-value'>{singleAdmin?.data?.email}</span>
                            </div>
                            <div className='info-item'>
                                <span className='info-label'>Contact Number</span>
                                <span className='info-value'>
                                    {singleAdmin?.data?.country_code} {singleAdmin?.data?.contact_number}
                                </span>
                            </div>
                            <div className='info-item'>
                                <span className='info-label'>Country</span>
                                <span className='info-value'>
                                    {getCountryNameByCode(singleAdmin?.data?.country_code)}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Professional Information Section */}
                    <div className='info-section'>
                        <h3 className='section-title'>Professional Information</h3>
                        <div className='info-items'>
                            <div className='info-item'>
                                <span className='info-label'>Department</span>
                                <span className='info-value'>{singleAdmin?.data?.department}</span>
                            </div>
                            <div className='info-item'>
                                <span className='info-label'>Designation</span>
                                <span className='info-value'>{singleAdmin?.data?.designation}</span>
                            </div>
                            <div className='info-item'>
                                <span className='info-label'>Joining Date</span>
                                <span className="info-value">
                                    {singleAdmin?.data?.created_at
                                        ? new Date(singleAdmin.data.created_at).toLocaleDateString('en-IN', {
                                            day: '2-digit',
                                            month: 'short',
                                            year: 'numeric',
                                        })
                                        : '-'}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Access Control Section */}
                {admin.data.role === 'super_admin' && (
                    <div className='access-control-section'>
                        <div className="section-header">
                            <h3 className='section-title'>Access Control</h3>
                            <div style={{ display: "flex", gap: "10px" }}>
                                <svg width="16" height="22" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.5" color='red' />
                                    <path d="M8 7.5V11.5M8 5V5.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" color='red' />
                                </svg>
                                <p className="section-description">
                                    Granting access allows this admin to add and modify configuration settings in the admin panel
                                </p>
                            </div>
                        </div>

                        {!showAccessInput ? (
                            <button
                                className="give-access-btn-new"
                                type="button"
                                onClick={handleClickGiveAccess}
                            >
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8 3.33334V12.6667M3.33334 8H12.6667" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                                {hasAccessCode ? 'Update Access' : 'Give Access'}
                            </button>
                        ) : (
                            <div className="access-input-wrapper">
                                <div className="access-type-selection">
                                    <label className="access-type-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={selectedAccessTypes.includes(ACCESS_TYPES.ADD)}
                                            onChange={() => handleAccessTypeToggle(ACCESS_TYPES.ADD)}
                                        />
                                        <span className="checkbox-label">
                                            <span className="checkbox-title">Add Access</span>
                                            <span className="checkbox-description">Allow admin to add new configurations</span>
                                        </span>
                                    </label>

                                    <label className="access-type-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={selectedAccessTypes.includes(ACCESS_TYPES.EDIT)}
                                            onChange={() => handleAccessTypeToggle(ACCESS_TYPES.EDIT)}
                                        />
                                        <span className="checkbox-label">
                                            <span className="checkbox-title">Edit Access</span>
                                            <span className="checkbox-description">Allow admin to modify existing configurations</span>
                                        </span>
                                    </label>
                                </div>

                                <div className="access-action-buttons">
                                    <button
                                        className="save-access-btn"
                                        type="button"
                                        onClick={handleSaveAccess}
                                        disabled={selectedAccessTypes.length === 0}
                                    >
                                        Save Access
                                    </button>
                                    <button
                                        className="cancel-access-btn"
                                        type="button"
                                        onClick={() => {
                                            setShowAccessInput(false);
                                            setSelectedAccessTypes([]);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* Current access code list */}
                        {hasAccessCode && !showAccessInput && (
                            <div className="access-code-list">
                                <div className="access-code-item">
                                    <div className="access-code-info">
                                        <span className="access-code-label">Current Access Types</span>
                                        <div className="access-types-badges">
                                            {singleAdmin.data.access_code
                                                .filter(type => type === ACCESS_TYPES.ADD || type === ACCESS_TYPES.EDIT)
                                                .map((type, index) => (
                                                    <span key={index} className="access-type-badge">
                                                        {type === ACCESS_TYPES.ADD ? 'Add Access' : 'Edit Access'}
                                                    </span>
                                                ))}
                                        </div>
                                    </div>
                                    <button
                                        type="button"
                                        className="remove-access-btn"
                                        onClick={handleRemoveAccess}
                                    >
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4 4L12 12M12 4L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                        </svg>
                                        Remove Access
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ViewAdmin;